export const getLastWeeksDate = () => {
  const now = new Date()

  return (
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) -
    7 * 86400000
  )
}

export const getTodayIcl = () => {
  const now = new Date()
  return (
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) +
    86400000
  )
}
